import { gql } from 'graphql-request'

export const REMOVE_STICKER = gql`
  mutation RemoveSticker($id: Int!) {
    removeSticker(id: $id) {
      id
    }
  }
`
